import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from 'generated/graphql';
import Modal, {
	ModalBackground,
	ModalContent,
} from 'packages/kakapo-ui-kit/components/modals/Modal';
import ModalHeader, {
	ModalHeaderTitle,
} from 'packages/kakapo-ui-kit/components/modals/ModalHeader';
import QuillText from 'packages/kakapo-ui-kit/components/editors/QuillText';
import PersonAvatar, {
	PersonAvatarSize,
} from 'packages/kakapo-ui-kit/components/users/PersonAvatar';
import { SectionTitle } from 'packages/kakapo-ui-kit/components/common/Headings';

export default function EvaluationNoteModal(props: {
	comment: graphql.Comment;
	onClose: () => void;
}) {
	const { t } = useTranslation();

	return (
		<ModalBackground>
			<Modal>
				<ModalHeader onCancel={() => props.onClose()}>
					<ModalHeaderTitle>{t('evaluation.submission.notes.title')}</ModalHeaderTitle>
				</ModalHeader>
				<ModalContent>
					<Flex flexDirection="row" alignItems="center" mb={3}>
						<Box flexGrow={0} flexShrink={0}>
							<PersonAvatar person={props.comment.user} size={PersonAvatarSize.Medium} />
						</Box>
						<Box flexGrow={1} flexShrink={1} ml={3}>
							<SectionTitle>
								{props.comment.user.firstName} {props.comment.user.lastName}
							</SectionTitle>
						</Box>
					</Flex>
					<QuillText quill={props.comment.content} />
				</ModalContent>
			</Modal>
		</ModalBackground>
	);
}
